import React, { useState, useEffect } from 'react';
import { db, doc, onSnapshot } from '@/firebase';

interface SiteLogoProps {
  className?: string;
  alt?: string;
}

export default function SiteLogo({ 
  className = "w-7 h-7 md:w-8 md:h-8 rounded-lg object-cover", 
  alt = "Azman204 Logo" 
}: SiteLogoProps) {
  const [customUrl, setCustomUrl] = useState<string | null>(null);
  const [useSvgFallback, setUseSvgFallback] = useState<boolean>(false);
  const [failed, setFailed] = useState<boolean>(false);

  useEffect(() => {
    try {
      const unsub = onSnapshot(doc(db, 'settings', 'website'), (snapshot) => {
        if (snapshot.exists() && snapshot.data()?.logoUrl) {
          setCustomUrl(snapshot.data().logoUrl);
          setUseSvgFallback(false);
          setFailed(false);
        }
      }, (err) => {
        console.warn('Error loading website logo setting:', err);
      });
      return () => unsub();
    } catch {
      // ignore
    }
  }, []);

  const currentSrc = customUrl || (useSvgFallback ? "/logo.svg" : "/logo.png");

  const handleError = () => {
    if (customUrl) {
      // If custom URL broke, fall back to default /logo.png
      setCustomUrl(null);
    } else if (!useSvgFallback) {
      // If /logo.png broke, fall back to /logo.svg
      setUseSvgFallback(true);
    } else {
      // If everything broke, show monogram
      setFailed(true);
    }
  };

  if (failed) {
    return (
      <div 
        className={`${className} bg-gradient-to-br from-slate-900 via-navy to-slate-950 border border-gold/40 flex items-center justify-center text-gold font-black shadow-md select-none`}
        title="Azman204"
      >
        <span className="text-sm font-extrabold tracking-tight">A</span>
      </div>
    );
  }

  return (
    <img
      src={currentSrc}
      alt={alt}
      className={className}
      onError={handleError}
    />
  );
}
